import TYPES from '../actions/types';

const INITIAL_STATE = {
  detail: null,
  getDetailError: false,
}

export default function(state = INITIAL_STATE, action) {
  switch(action.type) {
    case TYPES.detailsGetResult:
      return {
        ...state,
        detail: action.payload.data,
        getDetailError: false,
      };

    case TYPES.detailsGetResultError:
      return { ...state, getDetailError: true };

    default:
      return state;
  }
}
